"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferActivityLogsResponseDto = instanceOfOfferActivityLogsResponseDto;
exports.OfferActivityLogsResponseDtoFromJSON = OfferActivityLogsResponseDtoFromJSON;
exports.OfferActivityLogsResponseDtoFromJSONTyped = OfferActivityLogsResponseDtoFromJSONTyped;
exports.OfferActivityLogsResponseDtoToJSON = OfferActivityLogsResponseDtoToJSON;
exports.OfferActivityLogsResponseDtoToJSONTyped = OfferActivityLogsResponseDtoToJSONTyped;
var OfferActivityLogDto_1 = require("./OfferActivityLogDto");
/**
 * Check if a given object implements the OfferActivityLogsResponseDto interface.
 */
function instanceOfOfferActivityLogsResponseDto(value) {
    if (!('logs' in value) || value['logs'] === undefined)
        return false;
    return true;
}
function OfferActivityLogsResponseDtoFromJSON(json) {
    return OfferActivityLogsResponseDtoFromJSONTyped(json, false);
}
function OfferActivityLogsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'logs': (json['logs'].map(OfferActivityLogDto_1.OfferActivityLogDtoFromJSON)),
    };
}
function OfferActivityLogsResponseDtoToJSON(json) {
    return OfferActivityLogsResponseDtoToJSONTyped(json, false);
}
function OfferActivityLogsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'logs': (value['logs'].map(OfferActivityLogDto_1.OfferActivityLogDtoToJSON)),
    };
}
